export const getYScaleValue = (
  value: number,
  rangeStep: number,
  isYMax?: boolean
) => {
  const YScaleValue = !!isYMax
    ? Math.ceil(value / rangeStep) * rangeStep
    : Math.floor(value / rangeStep) * rangeStep
  return YScaleValue
}
